{
	"content": {
		"declarationDetailsSection": {
			"title": "Details van de verklaring",
			"description": "Om de verklaring aan te maken zijn de naam, het adres en het land van de verklaringhouder nodig. Deze informatie kan achteraf niet meer worden gewijzigd.",
			"customerLabel": "Klantaccount"
		},
		"provideDeclarationsDetailsSection": {
			"title": "Details van de verklaring invullen",
			"alertDescription": "De informatie die u verstrekt wordt permanent vastgelegd op de verklaring en kan achteraf niet meer worden gewijzigd.",
			"projectLabel": "Projectreferentie",
			"companyNameLabel": "Bedrijfsnaam",
			"streetLabel": "Straat",
			"zipCodeLabel": "Postcode",
			"cityLabel": "Stad",
			"countryLabel": "Land"
		}
	},
	"summary": {
		"title": "Samenvatting",
		"declarationTypeTitle": "Type verklaring",
		"customerProjectTitle": "Klantproject",
		"internalProjectOrProductTitle": "Intern project / product",
		"projectReferenceTitle": "Projectreferentie",
		"materialHeaderTitle": "Materiaal",
		"quantityHeaderTitle": "Hoeveelheid ({{unit}})",
		"totalTransferableCarbonReductionsTitle": "Toewijsbare CO\u2082-reducties ({{unit}})",
		"nonTransferableCarbonReductionTitle": "Niet-toewijsbare CO\u2082-reductie ({{unit}})"
	},
	"errorMessages": {
		"projectRequired": "Projectreferentie is verplicht",
		"companyNameRequired": "Bedrijfsnaam is verplicht",
		"streetRequired": "Straat is verplicht",
		"zipCodeRequired": "Postcode is verplicht",
		"cityRequired": "Stad is verplicht",
		"countryRequired": "Land is verplicht",
		"customerRequired": "Klant is verplicht"
	},
	"reviewDeclarationDetailsModal": {
		"title": "Controleer de samenvatting van de verklaring",
		"description": "Controleer de gegevens die u heeft ingevoerd op eventuele fouten.",
		"alertDescription": "De informatie die u heeft verstrekt wordt permanent vastgelegd op de verklaring en kan achteraf niet meer worden gewijzigd.",
		"typeSectionTitle": "1. Type",
		"declarationTypeLabel": "Type verklaring",
		"customerProjectTitle": "Klantproject",
		"internalProjectOrProductTitle": "Intern project / product",
		"projectReferenceLabel": "Projectreferentie",
		"materialSectionTitle": "2. Materiaal",
		"materialHeaderTitle": "Materiaal",
		"quantityHeaderTitle": "Hoeveelheid ({{unit}})",
		"totalCarbonReductionsLabel": "Totale CO₂-reducties ({{unit}})",
		"declarationSectionTitle": "3. Verklaring",
		"companyNameLabel": "Bedrijfsnaam",
		"streetLabel": "Straat",
		"zipCodeLabel": "Postcode",
		"cityLabel": "Stad",
		"countryLabel": "Land",
		"backTitle": "Terug",
		"submitTitle": "Ja, alles klopt"
	},
	"submitTitle": "Verklaring aanmaken",
	"backTitle": "Terug"
}
